import { createFileRoute } from '@tanstack/react-router'
import { SupportPage } from '@/features/auth/support-page'
export const Route = createFileRoute('/support')({ component: SupportPage })
